import { useState } from "react";
import PropTypes from "prop-types";

// Helpers
import { filterTree } from "@/Common/helpers/Arrays/tree";

// MUI
import { Grid, Stack } from "@mui/material";

// Components
import SideTreeView from "@/Layouts/components/SideBars/SideTreeView";
import SearchInput from "@/Layouts/components/Basics/SearchInput";
import SideTreeActions from "@/Layouts/components/SideBars/SideTreeView/SideTreeActions";

const getFilteredTree = (tree = [], args = undefined) => {
	const { text = "", index = "title", searchIn = "list" } = args || {};
	if (!tree?.length || !text || !index) {
		return tree;
	}
	return filterTree(tree, { text, index, dep: searchIn });
};

function InnerTreeContent(props) {
	const {
		search = "",
		searchBy = "title",
		searchIn = "list",
		appendSection = null,
		sideBarSection = null,
		appendProps = null,
		sideBarProps = null,
	} = props;

	const filteredAppendTree = getFilteredTree(appendProps?.tree, { text: search, index: searchBy, searchIn });
	const filteredSideBarTree = getFilteredTree(sideBarProps?.tree, { text: search, index: searchBy, searchIn });

	return (
		<Stack mt={1.8}>
			{appendProps ? <SideTreeView {...appendProps} tree={filteredAppendTree} /> : appendSection}
			{sideBarProps ? <SideTreeView {...sideBarProps} tree={filteredSideBarTree} /> : sideBarSection}
		</Stack>
	);
}
InnerTreeContent.propTypes = {
	search: PropTypes.string,
	searchBy: PropTypes.string,
	searchIn: PropTypes.string,
	appendSection: PropTypes.node,
	sideBarSection: PropTypes.node,
	appendProps: PropTypes.object,
	sideBarProps: PropTypes.object,
};

export function SideBarContent(props) {
	const { searchProps = null } = props;
	const {
		value = "",
		searchBy = "title",
		searchIn = "list",
		loading = false,
		onChangeSearchAction = () => {},
		onClearSearchAction = () => {},
	} = searchProps || {};

	const [searchValue, setSearchValue] = useState(value);

	const isSearchable = Boolean(searchProps);

	const handleSearch = (localValue = "") => {
		setSearchValue(localValue);
		onChangeSearchAction?.(localValue);
	};

	const handleClearSearch = () => {
		setSearchValue("");
		onClearSearchAction?.();
	};

	return (
		<Grid item sx={{ width: "100%" }}>
			{isSearchable && (
				<Stack px={"15px"}>
					<SearchInput value={searchValue} loading={loading} clearSearch={handleClearSearch} onChange={handleSearch} />
				</Stack>
			)}

			<InnerTreeContent {...props} search={searchValue} searchBy={searchBy} searchIn={searchIn} />
		</Grid>
	);
}
SideBarContent.propTypes = {
	appendSection: PropTypes.node,
	sideBarSection: PropTypes.node,
	appendProps: PropTypes.object,
	sideBarProps: PropTypes.object,
	searchProps: PropTypes.shape({
		value: PropTypes.string,
		loading: PropTypes.bool,
		onChangeSearchAction: PropTypes.func,
		onClearSearchAction: PropTypes.func,
	}),
};

export default function AppSideBar(props) {
	const { actions = null } = props;

	return (
		<Grid
			container
			direction="column"
			justifyContent="space-between"
			alignItems="flex-start"
			className="main-side-selector"
			sx={{ paddingTop: "15px", paddingBottom: "10px" }}
		>
			<Grid item sx={{ width: "100%" }}>
				<SideBarContent {...props} />
			</Grid>

			<Grid item sx={{ width: "100%" }}>
				{Boolean(actions) && <SideTreeActions {...actions} />}
			</Grid>
		</Grid>
	);
}
AppSideBar.propTypes = {
	appendSection: PropTypes.node,
	sideBarSection: PropTypes.node,
	appendProps: PropTypes.object,
	sideBarProps: PropTypes.object,
	actions: PropTypes.object,
	searchProps: PropTypes.shape({
		value: PropTypes.string,
		searchBy: PropTypes.string,
		searchIn: PropTypes.string,
		loading: PropTypes.bool,
		onChangeSearchAction: PropTypes.func,
		onClearSearchAction: PropTypes.func,
	}),
};
